import { render, staticRenderFns } from "./lightspot.vue?vue&type=template&id=17857f74&scoped=true&"
import script from "./lightspot.vue?vue&type=script&lang=js&"
export * from "./lightspot.vue?vue&type=script&lang=js&"
import style0 from "./lightspot.vue?vue&type=style&index=0&id=17857f74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17857f74",
  null
  
)

export default component.exports